import React from "react";
import {internalApi} from "../../common/axios";
import toast from "react-hot-toast";
import { Select, Checkbox, Button, Popconfirm } from "antd";
import dayjs from "dayjs";
import TablePage from "../../pages/tablePage/TablePage";
import {ROLE_OPTIONS} from "../../shared/utils/enum";

const Admin = () => {
    const datatableRef = React.useRef();

    const handleRoleChange = async (adminId, newRole) => {
        try {
            await internalApi.put(`/admin/${adminId}/role`, {role: newRole});
            toast.success('역할이 성공적으로 변경되었습니다.');
            datatableRef.current();
        } catch (error) {
            console.error(error);
        }
    };

    const handleOnOffChange = async (adminId, newOnOff) => {
        try {
            await internalApi.put(`/admin/${adminId}/onOff`, {onOff: newOnOff});
            toast.success('상태가 성공적으로 변경되었습니다.');
            datatableRef.current();
        } catch (error) {
            toast.error('상태 변경에 실패했습니다.');
            console.error(error);
        }
    };

    const handleDelete = async (adminId) => {
        try {
            await internalApi.delete(`/admin/${adminId}`);
            toast.success('관리자가 성공적으로 삭제되었습니다.');
            datatableRef.current();
        } catch (error) {
            toast.error('관리자 삭제에 실패했습니다.');
            console.error(error);
        }
    }

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            search: true,
        },
        {
            title: '이름',
            dataIndex: 'name',
            search: true,
        },
        {
            title: '메일 주소',
            dataIndex: 'mail',
        },
        {
            title: '권한',
            dataIndex: 'role',
            render: (role, record) => (
                <Select
                    value={role}
                    onChange={(value) => handleRoleChange(record.id, value)}
                    style={{ minWidth: 120 }}
                    size="small"
                >
                    {ROLE_OPTIONS.map(option => (
                        <Select.Option key={option.value} value={option.value}>
                            {option.label}
                        </Select.Option>
                    ))}
                </Select>
            ),
        },
        {
            title: '계정 활성',
            dataIndex: 'onOff',
            render: (onOff, record) => (
                <Checkbox
                    checked={onOff}
                    onChange={(e) => handleOnOffChange(record.id, e.target.checked)}
                />
            ),
        },
        {
            title: '가입일',
            dataIndex: 'created',
            render: (created) => dayjs(created).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
            title: '회원 삭제',
            dataIndex: 'id',
            render: (id) => (
                <Popconfirm title="정말 삭제하시겠습니까?" onConfirm={() => handleDelete(id)} okText="삭제" cancelText="취소">
                    <Button size="small" danger className="admin-delete-button">삭제</Button>
                </Popconfirm>
            ),
        }
    ];

    const props = {
        columns,
        refreshRef: datatableRef,
        url: 'admin',
    }

    return (
            <TablePage {...props} />
    );
}

export default Admin;